/* jld 6.10.2026: desktop mega menu panels (JLD mega menu panel blocks) shrink to the screen height so the whole panel
   is visible without scrolling. Sets --jmm-fit (1 = designed size, lowest 0.4) on .mega-menu__content; jld-megamenu.css
   scales picture rows, paddings and heading sizes with it. Runs when the page loads, on resize, when the theme editor
   re-renders the header and every time a panel opens. Off per panel: data-jmm-fit="false" (block setting). */
(function () {
  var MIN = 0.4, SAFE = 0.985, GAP = 8, mq = window.matchMedia('(min-width: 990px)'), tResize = null;
  function contents() {
    return Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu .mega-menu--jld .mega-menu__content'));
  }
  function fitOne(c) {
    var p = c.querySelector('.jld-mm');
    if (!p) return;
    if (!mq.matches || p.getAttribute('data-jmm-fit') === 'false') { c.style.removeProperty('--jmm-fit'); return; }
    var d = c.closest('details'), f = 1;
    c.style.setProperty('--jmm-fit', '1');
    for (var i = 0; i < 6; i++) {
      var avail = c.clientHeight;
      if (d && d.open) avail = Math.min(avail, window.innerHeight - c.getBoundingClientRect().top - GAP);
      var need = c.scrollHeight;
      if (avail <= 0 || need <= avail) break;
      f = Math.max(MIN, f * (avail / need) * SAFE);
      c.style.setProperty('--jmm-fit', f.toFixed(3));
      if (f <= MIN) break;
    }
  }
  function fitAll() { contents().forEach(fitOne); }
  function bind() {
    contents().forEach(function (c) {
      var d = c.closest('details');
      if (!d || d.getAttribute('data-jmm-fit-bound')) return;
      d.setAttribute('data-jmm-fit-bound', '1');
      d.addEventListener('toggle', function () { if (d.open) fitOne(c); });
    });
  }
  function init() {
    bind(); fitAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    window.addEventListener('load', fitAll);
    window.addEventListener('resize', function () { clearTimeout(tResize); tResize = setTimeout(fitAll, 120); });
    document.addEventListener('shopify:section:load', function () { bind(); fitAll(); });
    document.addEventListener('shopify:block:select', fitAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
